import { useEffect, useState } from "react";
import Preview from "../../preview/Preview";
import "./Send.css";

const Send = ({
  campaignTitle,
  campaignSource,
  campaignType,
  property,
  leads,
  template,
  complete,
  completed,
  progressMessage,
  templateHtml,
}) => {
  const [modalStatus, setModalStatus] = useState(false);

  useEffect(() => {
    if (complete === true) {
    }
  }, [complete]);
  const containerStyles = {
    height: 25,
    width: "100%",
    backgroundColor: "#e0e0de",
    borderRadius: 50,
  };

  const fillerStyles = {
    height: "100%",
    width: `${completed}%`,
    backgroundColor: "#5e42c2",
    borderRadius: "inherit",
    textAlign: "center",
  };

  const labelStyles = {
    padding: 5,
    color: "white",
    fontWeight: "bold",
  };
  return complete === true ? (
    <div className="progress-bar">
      <h4 className="marketing-design-heading custom-send-heading">
        {progressMessage}
      </h4>
      <div style={containerStyles}>
        <div style={fillerStyles}>
          <span style={labelStyles}>{`${completed}%`}</span>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <h4 className="marketing-design-heading">Campaign Summary</h4>
      <div className="send-slider-container">
        <table>
          <tbody>
            <tr>
              <td className="marketing-heading-td">Campaign Title</td>
              <td className="marketing-body-td">{campaignTitle}</td>
            </tr>
            <tr>
              <td className="marketing-heading-td">Campaign Type</td>
              <td className="marketing-body-td">{campaignType}</td>
            </tr>
            <tr>
              <td className="marketing-heading-td">Campaign Source</td>
              <td className="marketing-body-td">{campaignSource}</td>
            </tr>
            <tr>
              <td className="marketing-heading-td">Property</td>
              <td className="marketing-body-td">{property?.propertyTitle}</td>
            </tr>
            <tr>
              <td className="marketing-heading-td">Leads</td>
              <td className="marketing-body-td" style={{ display: "flex" }}>
                {leads.map((sLead, i) => {
                  return (
                    <span style={{ marginRight: 2 }}>
                      {sLead?.name}
                      {leads.length - 1 !== i ? ", " : ""}
                    </span>
                  );
                })}
              </td>
            </tr>
            <tr>
              <td className="marketing-heading-td">Email Preview</td>
              <td className="marketing-body-td">
                <p
                  className="preview-template"
                  onClick={() => {
                    setModalStatus(true);
                  }}
                >
                  Preview
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Preview
        {...{
          modalStatus,
          setModalStatus,
          template,
          property,
        }}
      />
    </div>
  );
};

export default Send;
